export enum PaymentType {
  POSTPAYMENT = 'Postpayment',
  PREPAYMENT = 'Prepayment',
}